import ORFIDropzone from 'components/files/Dropzone'
import RPGDInfo from 'components/files/RPGDInfo'
import moment from 'moment'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import I18n from 'resources/i18n/I18n'
import EventApi from 'services/eventApi'
import CONSTANTS from '../../utils/constants'
import StatusCompact from './StatusCompact'
import './status.scss'

const Status = ({
  status,
  files,
  isFormDisabled,
  allProcessingComplaints,
  lastProcessingPrejudice,
  previousAutreActions,
  previousAutrePrejudices,
}) => {
  const currentUser = useSelector((state) => state.userReducer.user)

  const statusConst = CONSTANTS.STATUS.find((x) => x.id === status.status)
  const formatDate = () => {
    if (!status.date) return moment().format('DD/MM/YYYY')
    const dateObj = moment(status.date)
    if (!dateObj.isValid()) return moment().format('DD/MM/YYYY')
    return dateObj.format('DD/MM/YYYY à HH:mm')
  }

  const isValidated = status.status === CONSTANTS.STATUS_LIST.VALIDATED
  const hasProcessingData = allProcessingComplaints?.length > 0 || (lastProcessingPrejudice && Object.values(lastProcessingPrejudice).some(Boolean))
  const showValidatedSummary = isValidated && hasProcessingData

  return (
    <div className="container card-status mb-3">
      <div className="label mb-2" style={{ backgroundColor: statusConst.color }}>
        {statusConst.label}
      </div>
      <div className="author mb-2">
        <div>
          {I18n.t('EventBy')} {status.idUser ? status.idUser : currentUser.label}
        </div>
        <div>{formatDate()}</div>
      </div>

      {showValidatedSummary && (
        <StatusCompact
          status={{ ...status, ...lastProcessingPrejudice, complaints: allProcessingComplaints }}
          isFirstProcessing={true}
          previousAutreActions={previousAutreActions}
          previousAutrePrejudices={previousAutrePrejudices}
        />
      )}

      {files?.length > 0 && currentUser.group.enabledAttachmentAndComment && (
        <ORFIDropzone
          className="mt-3"
          files={files}
          setFiles={() => {}}
          title={I18n.t('EventFiles')}
          subtitle={<RPGDInfo />}
          downloadFileOnServer={EventApi.downloadFile}
          deleteFileOnServer={EventApi.deleteFile}
          disabled={isFormDisabled}
          readOnly={true}
        />
      )}
    </div>
  )
}

export default memo(Status)
